import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithAuth from "./baseQueryWithAuth";

const stripeApi = createApi({
  reducerPath: "stripe",
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    status: build.query({
      query: () => "/",
    }),
    getCustomer: build.query({
      query: (user) => ({
        url: "/get-customer",
        method: "GET",
        params: { customerId: user },
      }),
    }),
    createSetupIntent: build.mutation({
      query: (data) => ({
        url: "/create-setup-intent",
        method: "POST",
        body: data,
      }),
    }),
    createInvoice: build.mutation({
      query: (data) => ({
        url: "/create-invoice",
        method: "POST",
        body: data,
      }),
    }),
    getReceipt: build.query({
      query: ({ invoiceId }) => ({
        url: "/get-receipt",
        method: "GET",
        params: { invoiceId },
      }),
    }),
    getInvoice: build.query({
      query: ({ invoiceId }) => ({
        url: "/get-invoice",
        method: "GET",
        params: { invoiceId },
      }),
    }),
    listPaymentMethods: build.query({
      query: (customerId) => ({
        url: "/list-payment-methods",
        method: "GET",
        params: { customerId },
      }),
    }),
    detachPaymentMethod: build.mutation({
      query: (data) => ({
        url: "/detach-payment-method",
        method: "POST",
        body: data,
      }),
    }),
    setDefaultPaymentMethod: build.mutation({
      query: (data) => ({
        url: "/set-default-payment-method",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export default stripeApi;

export const {
  useStatusQuery,
  useGetCustomerQuery,
  useLazyGetCustomerQuery,
  useCreateSetupIntentMutation,
  useCreateInvoiceMutation,
  useLazyGetReceiptQuery,
  useLazyGetInvoiceQuery,
  useListPaymentMethodsQuery,
  useDetachPaymentMethodMutation,
  useSetDefaultPaymentMethodMutation,
} = stripeApi;
